import React from 'react'
import { Link } from 'react-router-dom'
import buildQuery from '../../helpers/buildQuery'

function StoryHeader({student, customer, active, sectionClick = () => {}})
{
    if (active !== "high" && active !== "middle" && active !== "elementary")
        throw `Stories Header's active type must be one of the following: high, middle, elementary (${active})`
    
    const standardVariables = buildQuery({ student: student, customer: customer })
    return (
        <div class = "row">
            <div class = "col-sm-10 offset-sm-1">
                <div class = "row subheader-text">
                    <div class = "col-sm-4">
                        <Link to = {`/probes/stories/elementary?${standardVariables}`} onClick={sectionClick} class = {`btn btn-secondary alternate-fill btn-lg ${active === "elementary" ? "active" : ""}`}>Elementary</Link>
                    </div>
                    
                    <div class = "col-sm-4">
                        <Link to = {`/probes/stories/middle?${standardVariables}`} onClick={sectionClick} class = {`btn btn-secondary alternate-fill btn-lg ${active === "middle" ? "active" : ""}`}>Middle</Link>
                    </div>
                    
                    <div class = "col-sm-4">
                        <Link to = {`/probes/stories/high?${standardVariables}`} onClick={sectionClick} class = {`btn btn-secondary alternate-fill btn-lg ${active === "high" ? "active" : ""}`}>High</Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default StoryHeader
